import ListItem from '@mui/material/ListItem';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { LoadingSkeleton } from 'components';
import { useEffect, useMemo } from 'react';
import { useEditUserMutation, useGetCurrenciesQuery, useGetUserQuery } from 'store/api/version-api.slice';

const DEFAULT_CURRENCY_VALUE = 'USD';

const AccountCurrency = ({ paymentProcessor = '' }) => {
	const { data: user, isFetching: isUserFetching } = useGetUserQuery();
	const { data: currenciesResponse = {}, isLoading: areCurrenciesLoading } = useGetCurrenciesQuery();

	const currencies = useMemo(() => {
		if (!currenciesResponse.result) {
			return [];
		}

		let currenciesMap = currenciesResponse.result[paymentProcessor];

		if (!currenciesMap) {
			currenciesMap = currenciesResponse.result.square;
		}

		return Object.entries(currenciesMap).map(([symbol, label]) => ({
			label,
			value: symbol
		}));
	}, [currenciesResponse.result, paymentProcessor]);

	const userPaymentCurrency = user?.payment_currency || '';

	const [editUser, { isLoading: isEditLoading }] = useEditUserMutation();

	const handleCurrencyChange = e => {
		const selectedCurrency = e.target.value;

		editUser({ payment_currency: selectedCurrency ?? DEFAULT_CURRENCY_VALUE });
	};

	useEffect(() => {
		if (user && !userPaymentCurrency && !areCurrenciesLoading) {
			editUser({ payment_currency: DEFAULT_CURRENCY_VALUE });
		}
	}, [userPaymentCurrency, user, editUser, areCurrenciesLoading]);

	const isLoading = !user || areCurrenciesLoading;

	const selectValue = currencies.length ? userPaymentCurrency : '';

	return (
		<>
			<ListItem>
				<Typography variant="h5" color="primary" sx={{ width: '100%' }}>
					{isLoading ? <Skeleton variant="rounded" /> : 'CURRENCY'}
				</Typography>
			</ListItem>
			<ListItem>
				<LoadingSkeleton isLoading={isLoading}>
					<Select
						fullWidth
						onChange={handleCurrencyChange}
						value={selectValue}
						disabled={isEditLoading || isUserFetching}
					>
						{currencies.map(currency => (
							<MenuItem key={currency.value} value={currency.value}>
								{currency.label}
							</MenuItem>
						))}
					</Select>
				</LoadingSkeleton>
			</ListItem>
		</>
	);
};

export default AccountCurrency;
